module.exports = __webpack_public_path__ + "images/application/i-warning-white-d1fb0c67.svg";